import React, { Component } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash'
import { Modal, Button, Checkbox, RadioButton, Notification } from 'carbon-components-react';
import { StepCard } from '../../index';
import initials from '../../../fixtures/unitsOfmeasurement';

class SizeQuantity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      openModal: false,
      listSizePredefined: [],
      widthSize: 0,
      heightSize: 0,
      indexEdit: 0,
      listAplicationValues: [],
      openModalEdit: false,
      idUrl: null,
      openNotification: false,
      descriptionSize: "",
    };
  }

  verifyChecked = (list, item) => {
    let values = {
      checked: false,
      amountSize: 0,
      value: item
    };

    list.forEach(element => {
      if (element.idTamanho === item.value.id) {
        values = {
          checked: true,
          amountSize: element.quantidade
        }
      }
    });

    return values;
  }

  componentWillReceiveProps = async (newProps) => {
    const { dataProduct, dataRequest, isFinished } = newProps;
    const { listSizePredefined } = this.state;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    let list = [];
    let listCheckeds = [];

    if (!isFinished && dataRequest.detalhes && dataRequest.hasChanged && dataProduct.listSizes && dataRequest.detalhes.length === 0 && dataProduct.listSizes.length === 0) {
      await this.setState({
        listSizePredefined: [],
        descriptionSize: ""
      })

      this.loadProps();
    } else if ((dataProduct.dataFilters && dataProduct.dataFilters.listaTamanhos && dataProduct.dataFilters.listaTamanhos.length > 0) && !listSizePredefined.length) {
      dataProduct.dataFilters.listaTamanhos.forEach(item => {
        list.push({ checked: false, amountSize: 0, value: item });
      });

      if (existRequest && dataRequest.detalhes.length) {
        listCheckeds = dataRequest.detalhes.map(item => ({
          idTamanho: item.tamanhos[0].idTamanho,
          quantidade: item.quantidade
        }));

        if (listCheckeds.length) {
          list = list.map(obj => ({
            checked: this.verifyChecked(listCheckeds, obj).checked,
            amountSize: this.verifyChecked(listCheckeds, obj).amountSize,
            value: obj.value,
          }))
        }
      }

      await this.setState({
        listSizePredefined: list,
        openNotification: false,
        disabledAdvance: false
      });
    } else if (!dataProduct.dataFilters || dataProduct.dataFilters.listaTamanhos.length === 0) {
      await this.setState({
        listSizePredefined: []
      })
    }
  }

  returnCheckedsDataRequest = (value, index) => {
    const { dataRequest, dataProduct } = this.props;
    const { dataFilters } = dataProduct || {};
    const { detalhes } = dataRequest;
    const { listaTamanhos } = dataFilters;
    const multiSelect = dataFilters && dataFilters.multSelecaoTamanhos

    if ((value.isAlturaVariavel && value.altura === 0) || (value.isLarguraVariavel && value.largura === 0)) {
      let objReturn = {}
      for (const item of detalhes) {
        let obj = item.tamanhos.find(t => t.idTamanho === value.id)
        if (obj) {
          obj = { ...value, ...obj, idTamanho: obj.idTamanho || value.id }
          objReturn = {
            checked: false,
            amountSize: item.quantidade,
            value: obj,
            heightSize: obj.altura,
            widthSize: obj.largura,
            index
          }
        }
      }
      const existReturn = Object.prototype.hasOwnProperty.call(objReturn, "checked");

      if (existReturn) {
        setTimeout(() => {
          if (multiSelect)
            this.checkedSizes(true, objReturn.index, true)
          else
            this.radioSizes(objReturn.index);
        }, 500);
        return objReturn
      }

    } else {
      let objReturn = {};
      for (const item of detalhes) {
        let obj = item.tamanhos.find(t => t.idTamanho === value.id);
        if (obj) {
          const tamanho = listaTamanhos.find(t => t.id === obj.idTamanho);
          obj = { ...tamanho, ...obj };
          obj.nome = value.nome
          objReturn = {
            checked: true,
            amountSize: item.quantidade,
            value: obj,
          }
        }
      }

      const existReturn = Object.prototype.hasOwnProperty.call(objReturn, "checked");
      if (existReturn) {
        return objReturn;
      }
    }

    return false;
  }

  componentWillMount() {
    this.loadProps();
  }

  loadProps = () => {
    const { dataProduct } = this.props;
    const { aplicationSave } = dataProduct;
    const { listSizePredefined } = this.state;
    const list = [];

    if ((dataProduct.dataFilters && dataProduct.dataFilters.listaTamanhos && dataProduct.dataFilters.listaTamanhos.length > 0) && !listSizePredefined.length) {
      dataProduct.dataFilters.listaTamanhos.forEach((item, index) => {
        list.push(this.returnCheckedsDataRequest(item, index) || { checked: false, amountSize: 0, value: item });
      });
    }

    const aplication = aplicationSave && aplicationSave.label ? aplicationSave.label : 'Aplicação não foi selecionada';

    this.setState({
      listAplicationValues: [
        {
          id: 0,
          value: { nome: aplication },
          sizesInputed: [],
          sumSizes: { widthProp: 0, heightProp: 0 }
        }
      ],
      listSizePredefined: list
    });

    this.implementListSizes();
  }

  sumValues = values => {
    const larg = values.map(item => (item.largura));
    const stature = values.map(item => (item.altura));
    const largValue = larg.reduce(this.getSum, 0);
    const statureValue = stature.sort((a, b) => b - a)[0];
    const objSum = { widthProp: largValue, heightProp: statureValue };
    return objSum;
  }

  implementListSizes = () => {
    const { dataRequest } = this.props;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    const { detalhes } = dataRequest;

    if (detalhes && detalhes.length > 0) {
      this.setState({ descriptionSize: detalhes[0].tamanhoDescritivo });
    }
    if (existRequest) {
      const listRequest = detalhes.map((item, index) => ({
        id: index,
        quantityPerModel: item.quantidade,
        sizesInputed: item.tamanhos.map(obj => ({
          widthProp: obj.largura,
          heightProp: obj.altura
        })),
        sumSizes: this.sumValues(item.tamanhos),
        value: `Nome do produto ${index}`
      }));

      if (listRequest.length) {
        this.setState({
          listAplicationValues: listRequest
        });
      }
    }
  }

  componentWillUpdate = async () => {
    const { match, dataRequest } = this.props;
    const { idUrl } = this.state;
    const urlNow = idUrl;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    if (urlNow !== match.params.id) {
      if (!existRequest) {
        await this.setState({
          idUrl: match.params.id,
          listSizePredefined: [],
        });
      }

    }
  };

  renderDescription = () => {
    const { dataProduct } = this.props;
    const { listAplicationValues, listSizePredefined, descriptionSize } = this.state;
    const { variableSave, productSave } = dataProduct;
    const labelProduct = productSave && productSave.label ? productSave.label : '';

    let predefinedes = [];
    if (listSizePredefined) {
      predefinedes = listSizePredefined.filter(item => (
        item.checked === true
      ));
    }

    if (predefinedes.length) {
      return predefinedes.map((item, index) => (
        <p key={index}>
          <strong>
            {item.value.nome}
          </strong>
          {item.widthSize > 0 && (
            <span>
              {` ${item.widthSize > 0 ? item.widthSize : ""}x${item.heightSize > 0 ? item.heightSize : ""}`}
            </span>
          )}
          {` | quantidade: ${item.amountSize} `}
        </p>
      ))
    }

    // const labelVariable = variableSave && variableSave.value ? variableSave.value : "";
    const labelVariable = variableSave && (variableSave.value ? variableSave.value : variableSave.label ? variableSave.label : "");

    const isGlass = labelVariable === "unico" || labelVariable === "fracionado" || labelVariable === "sequencial";
    if (isGlass) {
      return listAplicationValues.map((item, index) => (
        <p key={item.id}>
          <strong>
            {`${labelProduct} ${index + 1} - `}
          </strong>
          {` ${item.sizesInputed && item.sizesInputed.length ? item.sizesInputed.length : 0} folha(s)  `}
          {`  total(cm) ${item.sumSizes.widthProp}x${item.sumSizes.heightProp} | quantidade: ${item.quantityPerModel !== undefined ? item.quantityPerModel : 0}`}
        </p>
      ));
    }
    if (descriptionSize && descriptionSize.length > 0) {
      return (
        <p className="description">
          <strong>
            {descriptionSize}
          </strong>
        </p>
      );
    }

    return (
      <p className="description">
        Tamanho do produto, sendo um tamanho padrão ou um campo variável que
        deverá ser combinado com a coluna de medida do campo variável.
      </p>
    )
  }

  onChangeValueSize = e => {
    this.setState({
      [e.target.id]: parseFloat(e.target.value.replace(/^0+/, ''), 10)
    });
  };

  onChangeValueQuantity = (event, index) => {
    const { target } = event;
    const { listAplicationValues } = this.state;
    const newValues = listAplicationValues;
    newValues[index].quantityPerModel = target.value;
    this.setState({
      listAplicationValues: newValues
    })
  }

  insertValueSize = () => {
    const {
      widthSize,
      heightSize,
      indexInput,
      listAplicationValues
    } = this.state;

    const currentObj = listAplicationValues[indexInput];

    if (widthSize >= 1 && heightSize >= 1) {
      listAplicationValues[indexInput].sizesInputed =
        [
          ...(currentObj.sizesInputed || []),
          {
            widthProp: widthSize,
            heightProp: heightSize
          }
        ];

      this.setState({
        listAplicationValues,
        openNotification: false
      }, () => {
        this.setState({
          widthSize: 0,
          heightSize: 0,
          openModal: false
        }, () => {
          this.sumSizes(indexInput);
        });
      }
      );
    } else {
      this.setState({
        openNotification: true
      })
    }

  };

  insertSizeDescription = event => {
    const { listAplicationValues } = this.state;
    const { target } = event;
    const descriptionSize = target.value;
    listAplicationValues[0].sizesInputed.descriptionSize = descriptionSize;
    this.setState({
      descriptionSize
    })
  }

  editValueSize = () => {
    const {
      indexEdit,
      indexInput,
      widthSize,
      heightSize,
      listAplicationValues
    } = this.state;
    const editados = [];
    let index = 0;
    const currentObj = listAplicationValues[indexInput];
    const currentObjSizes = currentObj.sizesInputed || [];

    if (widthSize >= 1 && heightSize >= 1) {
      for (const item of currentObjSizes) {
        if (indexEdit === index) {
          item.widthProp = widthSize;
          item.heightProp = heightSize;
        }
        editados.push(item);
        index++;
      }
      listAplicationValues[indexInput].sizesInputed = editados

      this.setState(
        {
          listAplicationValues
        }, () => {
          this.setState({
            widthSize: 0,
            heightSize: 0,
            openModalEdit: false,
            openNotification: false
          });

          this.sumSizes(indexInput);
        }
      );
    } else {
      this.setState({
        openNotification: true
      })
    }

  };

  modalInsertSize = index => {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
      openNotification: false,
      indexInput: index
    }));
  };

  modalEditSize = (idxEdit, idxArray) => {
    const { listAplicationValues } = this.state;
    const currentObj = listAplicationValues[idxArray]
      ? listAplicationValues[idxArray].sizesInputed[idxEdit]
      : { widthProp: 0, heightProp: 0 };

    this.setState(prevState => ({
      openModalEdit: !prevState.openModalEdit,
      indexEdit: idxEdit,
      openNotification: false,
      indexInput: idxArray,
      widthSize: currentObj.widthProp,
      heightSize: currentObj.heightProp
    }));
  };

  getSum = (total, num) => parseFloat(total) + parseFloat(num);

  sumSizes = (index) => {
    const { listAplicationValues } = this.state;
    const larg = [];
    const stature = [];
    if (listAplicationValues[index].sizesInputed) {
      listAplicationValues[index].sizesInputed.forEach(item => {
        larg.push(item.widthProp);
        stature.push(item.heightProp);
      });

      const largValue = larg.reduce(this.getSum, 0);
      const statureValue = stature.sort((a, b) => b - a)[0];
      const objSum = { widthProp: largValue, heightProp: statureValue };

      listAplicationValues[index].sumSizes = objSum
      this.setState({
        listAplicationValues,
      })

    }
  };

  incrementGlass = (material, variavel) => {
    const { listAplicationValues, indexInput } = this.state;

    const name = `${material} ${variavel} `;
    if (listAplicationValues[indexInput] && listAplicationValues[indexInput].value) {
      listAplicationValues[indexInput].value.nome = `${name + 1}`
    }
    this.setState(prevState => ({
      listAplicationValues: [
        ...prevState.listAplicationValues,
        {
          id: prevState.listAplicationValues.length,
          value: { nome: name + (listAplicationValues.length + 1) },
          sumSizes: { widthProp: 0, heightProp: 0 }
        }
      ]
    }));
  };

  removeItemListAplicationValue = index => {
    this.setState(prevState => {
      const newList = [...prevState.listAplicationValues];
      newList.splice(index, 1);
      return { listAplicationValues: newList };
    });
  };

  removeSize = (removeIdx, indexList) => {
    const { listAplicationValues } = this.state;
    const currentList = listAplicationValues;
    const newList = [];

    currentList.forEach((item, index) => {
      if (indexList === index) {
        item.sizesInputed.splice(removeIdx, 1);
      }
      newList.push(item);
    });

    this.setState({
      listAplicationValues: newList
    }, () => {
      this.sumSizes(indexList);
    })
  }

  emptyModifiqueVariable = () => {
    const { dataProduct } = this.props;
    const { variableSave } = dataProduct;
    const currentVariable = variableSave.value;
    let idx = 0;
    if (currentVariable.value !== variableSave.value && idx === 0) {
      this.setState({
        listAplicationValues: []
      })

      idx++;
    }
  }

  renderInsertGlass = () => {
    const { dataProduct } = this.props;
    const { listAplicationValues } = this.state;
    const { variableSave, materialSave } = dataProduct;

    const { label, value } = variableSave || {};
    const variableAplication = value || label || "";
    const materialAplication = materialSave && materialSave.label ? materialSave.label : ' ';

    return listAplicationValues.map((item, index) => (
      <div key={item.id}>
        <div className="bx--col-xs-12 bx--col-md-12 bx--col-lg-12">
          <div className="component-sizes-quantity">
            <strong>
              {materialAplication}
              {' '}
              {index + 1}
            </strong>
            <span>
              total(cm):
              <strong>
                {item.sumSizes.widthProp}
              </strong>
              x
              <strong>
                {item.sumSizes.heightProp}
              </strong>
              | quantidade:
              {item.quantityPerModel !== undefined ? item.quantityPerModel : 0}
            </span>
          </div>
          <br />
        </div>
        <div className="component-sizes-quantity">
          <div className="bx--row">
            {variableAplication !== 'unico' && (
              <div
                className="bx--col-xs-6 bx--col-md-3"
                onClick={() => this.modalInsertSize(index)}
              >
                <div className="size-input mg-bt-10">
                  <span className="label-size-input pointer">
                    <i className="material-icons">add_circle</i>
                    <br />
                    Inserir Medidas
                  </span>
                </div>
              </div>
            )}

            {variableAplication === 'unico' &&
              item.sizesInputed.length < 1 && (
                <div
                  className="bx--col-xs-6 bx--col-md-3"
                  onClick={() => this.modalInsertSize(index)}
                >
                  <div className="size-input mg-bt-10">
                    <span className="label-size-input pointer">
                      <i className="material-icons">add_circle</i>
                      <br />
                      Inserir Medidas
                    </span>
                  </div>
                </div>
              )}
            {item.sizesInputed &&
              item.sizesInputed.map((size, idx) => (
                <div
                  key={idx}
                  className="bx--col-xs-6 bx--col-md-3 animated rubberBand delay-5s"
                >
                  <div className="size-input-value">
                    <i
                      className="pointer trash-size material-icons"
                      onClick={() => this.removeSize(idx, index)}
                    >
                      remove_circle
                    </i>

                    <span className="label-size-input">
                      L:
                      {' '}
                      {size.widthProp}
                      {' '}
                      <br />
                      A:
                      {' '}
                      {size.heightProp}
                      {' '}
                    </span>
                    <span
                      className="edit-sizes pointer"
                      onClick={() => this.modalEditSize(idx, index)}
                    >
                      Editar
                    </span>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-xs-12 bx--col-md-3 v-md-margin button--clear button--icon">
            <input
              className="bx--text-input bx--text__input"
              type="text"
              placeholder="qtde: 1"
              id="amountSize"
              value={item.quantityPerModel || ""}
              onChange={e => this.onChangeValueQuantity(e, index)}
            />
          </div>
          <div className="bx--col-xs-12 bx--col-md-9 v-md-margin button--clear button--icon">
            {variableAplication !== "unico" && (
              <div>
                {
                  index === 0 ? (
                    <Button
                      kind="ghost"
                      className="h-sm-margin f-right"
                      onClick={() => this.incrementGlass(materialAplication, variableAplication)}
                    >
                      <i className="material-icons">add_circle</i>
                      {' '}
                      Adicionar
                    </Button>
                  ) : (
                    <Button
                      kind="danger"
                      className="h-sm-margin  v-md-margin clear-border-button f-right"
                      onClick={() => this.removeItemListAplicationValue(index)}
                    >
                      <i className="material-icons">remove_circle</i>
                      {' '}
                      Remover Vidro
                    </Button>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>
    ));
  };

  checkedSizes = (val, idx, isFirstLoad) => {
    const { listSizePredefined } = this.state;
    const copyList = _.clone(listSizePredefined, true);

    if (copyList && (copyList.length - 1) >= idx) {
      listSizePredefined[idx].checked = val
      listSizePredefined[idx].indice = idx
      if (listSizePredefined[idx].value.isLarguraVariavel) {
        listSizePredefined[idx].showWidthVariable = val
      }
      if (listSizePredefined[idx].value.isAlturaVariavel) {
        listSizePredefined[idx].showHeigthVariable = val
      }
      if (typeof isFirstLoad === 'undefined') {
        copyList.forEach((item, index) => {
          if (item.checked === false) {
            listSizePredefined[index].amountSize = 0
            listSizePredefined[index].heightSize = 0
            listSizePredefined[index].widthSize = 0
          }
        })
      }

      this.setState({
        listSizePredefined: copyList
      })
    }

  };

  radioSizes = (idx) => {
    const { listSizePredefined } = this.state;
    // console.log("listSizePredefined", listSizePredefined)
    const copyList = _.clone(listSizePredefined, true);
    let indice = 0;
    for (const item of copyList) {
      if (item.checked) {
        item.checked = false;
      }
      if (item.value.isLarguraVariavel) {
        item.showWidthVariable = false
      }

      if (item.value.isAlturaVariavel) {
        item.showHeigthVariable = false
      }

      listSizePredefined[idx].checked = true
      listSizePredefined[idx].indice = idx
      if (listSizePredefined[idx].value.isLarguraVariavel) {
        listSizePredefined[idx].showWidthVariable = listSizePredefined[idx].checked
      }
      if (listSizePredefined[idx].value.isAlturaVariavel) {
        listSizePredefined[idx].showHeigthVariable = listSizePredefined[idx].checked
      }

      if (indice !== idx) {
        item.amountSize = 0;
        item.widthSize = 0;
        item.heightSize = 0;
      }

      indice++;
    }

    this.setState({
      listSizePredefined: copyList
    })
  };

  insertValueAmount = (e, idx) => {
    const { listSizePredefined } = this.state;
    if (listSizePredefined && (listSizePredefined.length - 1) >= idx) {
      listSizePredefined[idx].amountSize = e.target.value
      this.setState({
        listSizePredefined
      })
    }
  };

  insertValueHeight = (e, idx) => {
    const { listSizePredefined } = this.state;
    const copyList = _.clone(listSizePredefined, true);
    const value = Number.isNaN(e.target.value) ? "" : parseFloat(e.target.value.replace(/^0+/, ''), 10);
    const valueHeight = Number.isNaN(value) ? "" : value;

    if (copyList && (copyList.length - 1) >= idx && (valueHeight >= 1 || valueHeight === "")) {
      copyList[idx].heightSize = valueHeight;
      const notNumber = Number.isNaN(copyList[idx].heightSize);
      const disabledAdvance = notNumber || copyList[idx].heightSize < 1;
      if (copyList[idx].heightSize >= 1 || notNumber) {
        this.setState({
          listSizePredefined: copyList,
          openNotification: false,
          disabledAdvance
        })
      } else {
        this.setState({
          openNotification: true,
          disabledAdvance
        });
      }

    }
  };

  insertValueWidth = (e, idx) => {
    const { listSizePredefined } = this.state;
    const copyList = _.clone(listSizePredefined, true);
    const value = Number.isNaN(e.target.value) ? "" : parseFloat(e.target.value.replace(/^0+/, ''), 10);
    const valueWidth = Number.isNaN(value) ? "" : value;
    if (copyList && (copyList.length - 1) >= idx && (valueWidth >= 1 || valueWidth === "")) {
      copyList[idx].widthSize = valueWidth;

      const notNumber = Number.isNaN(copyList[idx].heightSize);
      const disabledAdvance = notNumber || copyList[idx].widthSize < 1;
      if (copyList[idx].widthSize >= 1 || notNumber) {
        this.setState({
          listSizePredefined: copyList,
          openNotification: false,
          disabledAdvance
        })
      } else {
        this.setState({
          openNotification: true,
          disabledAdvance
        });
      }
    }
  };

  advance = async () => {
    const { saveStep, dataProduct } = this.props;
    const { variableSave, dataFilters } = dataProduct;
    const labelVariable = variableSave && variableSave.value ? variableSave.value : variableSave.label ? variableSave.label : "";

    const isGlass = labelVariable === "unico" || labelVariable === "fracionado" || labelVariable === "sequencial";
    const {
      listAplicationValues,
      listSizePredefined
    } = this.state;

    const itemList = listAplicationValues[0]
    const existObject = Object.prototype.hasOwnProperty.call(itemList, 'quantityPerModel')
    const valuesGlass = (listAplicationValues[0].sizesInputed.length) && existObject;
    const descriptionSize = Object.prototype.hasOwnProperty.call(itemList.sizesInputed, 'descriptionSize');
    const existDescription = descriptionSize && (listAplicationValues[0].sizesInputed.descriptionSize !== "");
    let validPredefined = true;
    let sizeOK = true;
    for (const item of listSizePredefined) {
      if (item.checked && (!item.amountSize || item.amountSize === "")) {
        validPredefined = false
      }
      if (item.checked && item.amountSize < (dataFilters.quantidadeMinima || 0)) {
        sizeOK = false;
        toast.warn(`A quantidade mínima é de ${dataFilters.quantidadeMinima}`)
      }
      console.log("item!", item)
      if (item.checked && item.value &&
        ((item.value.isAlturaVariavel && (!item.heightSize || item.heightSize <= 0)) ||
          (item.value.isLarguraVariavel && (!item.widthSize || item.widthSize <= 0)))) {
        validPredefined = false
      }
    }
    if (sizeOK === false) {
      // Evita que avance sem qtd mínima
    } else
      if (validPredefined === false && existDescription === false && isGlass === false) {
        toast.warn("Você precisa informar os valores de quantidade e tamanho..")
      }
      else if (isGlass) {
        let ok = true;
        listAplicationValues.forEach(p => {
          if (!p.quantityPerModel || p.quantityPerModel === "") {
            ok = false;
          }
        })

        if (ok === false) {
          toast.warn("Você precisa informar os valores de quantidade e tamanho.")
        } else {
          await saveStep({
            listSizes: listAplicationValues
          });
          console.log("listAplicationValues", listAplicationValues)
          await this.stepCardRef.toggleContent();
        }
      } else if (existDescription || valuesGlass || validPredefined) {
        if (listSizePredefined.length && !isGlass) {
          const checkedsPredefineds = await listSizePredefined.filter(item => (
            item.checked === true
          ));
          let okCheck = true;
          checkedsPredefineds.forEach(p => {
            console.log("p", p)
            // p.texto = dataProduct.listSizes ? dataProduct.listSizes[0].texto : '';
            if (p.showWidthVariable && (!p.widthSize || p.widthSize <= 0)) {
              okCheck = false;
            }
            if (p.showHeigthVariable && (!p.heightSize || p.heightSize <= 0)) {
              okCheck = false;
            }
          })
          if (okCheck) {
            await saveStep({
              listSizes: checkedsPredefineds
            });
          } else {
            toast.warn("Você precisa informar os valores de quantidade e tamanho!")
            return;
          }
          console.log("checkedsPredefineds", checkedsPredefineds)
        } else {
          await saveStep({
            listSizes: listAplicationValues
          });
          console.log("listAplicationValues", listAplicationValues)
        }

        await this.stepCardRef.toggleContent();
      } else {
        toast.warn("Você precisa informar os valores de quantidade e tamanho.")
      }
  }

  cancel = () => {
    this.stepCardRef.toggleContent();
  }

  initialsSize = id => {
    for (const item of initials) {
      if (parseInt(item.id, 10) === id) {
        return item.label;
      }
    }
    return ""
  }

  closeNotification = () => {
    this.setState({
      openNotification: false
    })
  }

  render() {
    const {
      advanced,
      openModal,
      heightSize,
      widthSize,
      openModalEdit,
      listSizePredefined,
      openNotification,
      descriptionSize,
      disabledAdvance
    } = this.state;

    const { style, dataProduct, disabledCard, isFinished } = this.props;
    const { variableSave, aplicationSave, dataFilters } = dataProduct;

    const materialAplication = aplicationSave && aplicationSave.label ? aplicationSave.label : '';
    const variableAplication = variableSave && variableSave.label ? variableSave.label : '';

    let labelVariable = variableSave && variableSave.value ? variableSave.value : "";
    if (labelVariable === "")
      labelVariable = variableSave ? variableSave.label : "";

    const isGlass = labelVariable === "unico" || labelVariable === "fracionado" || labelVariable === "sequencial";

    const listSizes = listSizePredefined.length ? listSizePredefined : [];
    const multiSelect = dataFilters && dataFilters.multSelecaoTamanhos;

    return (
      <div style={style}>


        <StepCard
          onRef={ref => {
            this.stepCardRef = ref;
          }}
          title="Tamanho e Quantidade"
          description={this.renderDescription()}
          isFinished={isFinished}
          onToogle={advanced}
          disabled={disabledCard}
          
        >
          <div className="bx--row">
            <div className="bx--col-md-12 bx--col-xs-12">
              {(openNotification && (listSizes.length || isGlass)) &&
                (
                  <Notification
                    kind="warning"
                    className="animated rubberBand delay-5s"
                    role="alert"
                    title="Atenção"
                    onCloseButtonClick={() => this.closeNotification()}
                    subtitle="Os valores inseridos devem ser maiores ou iguais a 1."
                    iconDescription="describes the close button"
                  />
                )
              }
            </div>
          </div>
          {isGlass ? (
            <div>
              {this.renderInsertGlass()}
            </div>
          ) : (
            <div>
              {listSizes.length ? (
                listSizes.map((item, index) => (
                  <div key={index}>
                    <div className="bx--row ">
                      <div className="bx--col-xs-6 bx--col-md-3 v-md-margin">
                        {index === 0 && (
                          <p className="legend-size-qtde-agency">
                            Tamanho:
                          </p>
                        )}

                        {multiSelect ? (
                          <Checkbox
                            id={`itemCheck${index}`}
                            className="check-sizes-requests"
                            labelText={item.value.nome}
                            checked={item.checked}
                            onChange={e => this.checkedSizes(e, index)}
                          />
                        ) :
                          (
                            <RadioButton
                              id={`itemCheck${index}`}
                              className="some-class"
                              name={`itemCheck${index}`}
                              labelText={item.value.nome}
                              checked={item.checked}
                              value={item.id || ""}
                              disabled={false}
                              onChange={() => this.radioSizes(index)}
                            />
                          )
                        }
                      </div>
                      <div className="bx--col-xs-6 bx--col-md-2 v-md-margin">
                        {index === 0 && (
                          <p className="legend-size-qtde-agency">
                            {`Qtd ${dataFilters.quantidadeMinima > 1 ? `(min: ${dataFilters.quantidadeMinima})` : ""}:`}
                          </p>
                        )}
                        <input
                          className="bx--text-input bx--text__input"
                          type="text"
                          placeholder={`qtde: 1 ${dataFilters.quantidadeMinima > 1 ? `(min: ${dataFilters.quantidadeMinima})` : ""}`}
                          min={dataFilters.quantidadeMinima}
                          id="amountSize"
                          value={item.amountSize > 0 && item.checked ? item.amountSize : ""}
                          onChange={e => this.insertValueAmount(e, index)}
                          disabled={!item.checked}
                        />
                      </div>
                    </div>

                    <div className="bx--row">
                      {item.value.isLarguraVariavel && item.showWidthVariable && (
                        <div className="bx--col-xs-6 bx--col-md-3 v-md-margin">
                          <label className="bx--label">
                            {`Largura (${this.initialsSize(item.value.unidadeMedida)})`}
                          </label>
                          <div className="icon-width"></div>
                          <input
                            className="bx--text-input bx--text__input"
                            type="number"
                            id="widthSize"
                            value={item.widthSize > 0 && item.checked ? item.widthSize : ""}
                            onChange={e => this.insertValueWidth(e, index)}
                          />
                        </div>
                      )}
                      {item.value.isAlturaVariavel && item.showWidthVariable && (
                        <div className="bx--col-xs-6 bx--col-md-3 v-md-margin">
                          <label className="bx--label">
                            {`Altura (${this.initialsSize(item.value.unidadeMedida)})`}
                          </label>
                          <div className="icon-height"></div>
                          <input
                            className="bx--text-input bx--text__input "
                            type="number"
                            id="heightSize"
                            value={item.heightSize > 0 && item.checked ? item.heightSize : ""}
                            onChange={e => this.insertValueHeight(e, index)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="bx--row">
                  <div className="bx--col-xs-6 bx--col-md-6">
                    <label className="bx--label">
                      Informe o tamanho desejado
                    </label>
                    <input
                      className="bx--text-input bx--text__input"
                      type="text"
                      placeholder="Ex: 650X1450"
                      value={descriptionSize}
                      onChange={e => this.insertSizeDescription(e)}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-md-12 v-md-margin">
              <Button
                onClick={this.advance}
                className="bx--btn btn-secondary-color"
                disabled={disabledAdvance}
              >
                Avançar
              </Button>
              <Button
                kind="ghost"
                className="bx--btn btn-secondary-outlined h-sm-margin"
                onClick={this.cancel}
              >
                Cancelar
              </Button>
            </div>
          </div>
          <div>
            {openModal &&
              (
                <Modal
                  modalHeading="Inserir medidas"
                  primaryButtonText="Adicionar"
                  secondaryButtonText="Cancelar"
                  onRequestSubmit={() => this.insertValueSize()}
                  onRequestClose={() => this.modalInsertSize()}
                  open={openModal}
                  className="component-quatity-sizes-modal"
                >
                  <p className="description">
                    Digite as medidas que deseja para
                    {' '}
                    <strong>
                      {materialAplication}
                      {` `}
                      {variableAplication}
                    </strong>
                  </p>
                  {openNotification &&
                    (
                      <Notification
                        kind="warning"
                        className="animated rubberBand delay-5s"
                        role="alert"
                        title="Atenção"
                        onCloseButtonClick={() => this.closeNotification()}
                        subtitle="Os valores inseridos devem ser maiores ou iguais a 1."
                        iconDescription="describes the close button"
                      />
                    )
                  }

                  <div className="bx--row">
                    <div className="bx--col-xs-12 bx--col-md-6">
                      <label className="bx--label">Largura(cm)</label>
                      <input
                        className="bx--text-input bx--text__input"
                        type="number"
                        id="widthSize"
                        name="widthSize"
                        value={widthSize}
                        onChange={e => this.onChangeValueSize(e)}
                      />
                      <br />
                      <label className="bx--label ">Altura(cm)</label>
                      <input
                        className="bx--text-input bx--text__input"
                        type="number"
                        id="heightSize"
                        name="heightSize"
                        value={heightSize}
                        onChange={e => this.onChangeValueSize(e)}
                      />
                    </div>
                  </div>
                </Modal>
              )
            }
          </div>
          <div>
            {openModalEdit && (
              <Modal
                modalHeading="Inserir medidas"
                primaryButtonText="Adicionar"
                secondaryButtonText="Cancelar"
                onRequestSubmit={() => this.editValueSize()}
                onRequestClose={() => this.modalEditSize()}
                open={openModalEdit}
                className="component-quatity-sizes-modal"
              >
                {openNotification &&
                  (
                    <Notification
                      kind="warning"
                      className="animated rubberBand delay-5s"
                      role="alert"
                      title="Atenção"
                      onCloseButtonClick={() => this.closeNotification()}
                      subtitle="Os valores inseridos devem ser maiores ou iguais a 1."
                      iconDescription="describes the close button"
                    />
                  )
                }
                <p className="description">
                  Digite as medidas que deseja para
                  {' '}
                  <strong>
                    {materialAplication}
                    {' '}
                    {variableAplication}
                  </strong>
                </p>
                <div className="bx--row">
                  <div className="bx--col-xs-12 bx--col-md-6">
                    <label className="bx--label">Largura</label>
                    <input
                      className="bx--text-input bx--text__input"
                      type="number"
                      id="widthSize"
                      name="widthSize"
                      value={widthSize}
                      onChange={e => this.onChangeValueSize(e)}
                    />
                    <br />
                    <label className="bx--label ">Altura</label>
                    <input
                      className="bx--text-input bx--text__input"
                      type="number"
                      id="heightSize"
                      name="heightSize"
                      value={heightSize}
                      onChange={e => this.onChangeValueSize(e)}
                    />
                  </div>
                </div>
              </Modal>
            )}
          </div>
        </StepCard>
      </div>
    );
  }
}

export default SizeQuantity;



// WEBPACK FOOTER //
// ./src/components/agency/requests/SizeQuantity.js